import { MutationFn, UseQueryFn } from 'shared-ui';

import {
  AddPrzejscieBody,
  AddStrefaBody,
  DostepneTkdQuery,
  DostepneTkdResponse,
  MonitoringObecnosci,
  ObecnoscPosiadaczeResponse,
  ObecnoscStrefyResponse,
  PrzejsciaQuery,
  PrzejsciaResponse,
  PrzejscieSerweryResponse,
  Strefa,
  StrefyResponse,
} from './strefy.types';

export const fetchStrefy: UseQueryFn<null, StrefyResponse> = () => {
  return {
    endpoint: '/strefa',
  };
};

export const addStrefa: MutationFn<AddStrefaBody, Pick<Strefa, 'id'>> = (body) => {
  return {
    endpoint: '/strefa',
    method: 'POST',
    body,
  };
};

export const deleteStrefa: MutationFn<string, void> = (id) => {
  return {
    endpoint: `/strefa/${id}`,
    method: 'DELETE',
  };
};

export const fetchMonitoringObecnosci: UseQueryFn<null, MonitoringObecnosci> = () => {
  return {
    endpoint: '/monitoring-obecnosci',
  };
};

export const fetchObecnoscStrefy: UseQueryFn<null, ObecnoscStrefyResponse> = () => {
  return {
    endpoint: '/obecnosc/strefy',
  };
};

/** Query string (`ObecnoscPosiadaczeQuery`) goes through `useQuery`'s `args`. */
export const fetchObecnoscPosiadacze: UseQueryFn<string, ObecnoscPosiadaczeResponse> = (strefaId) => {
  return {
    endpoint: `/obecnosc/strefy/${strefaId}/posiadacze`,
  };
};

export const fetchPrzejscieSerwery: UseQueryFn<null, PrzejscieSerweryResponse> = () => {
  return {
    endpoint: '/przejscie/serwery',
  };
};

/** Query string (`rcpId` included) goes through `useQuery`'s `args`. */
export const fetchPrzejscia: UseQueryFn<PrzejsciaQuery, PrzejsciaResponse> = () => {
  return {
    endpoint: '/przejscie',
  };
};

export const fetchDostepneTkd: UseQueryFn<DostepneTkdQuery, DostepneTkdResponse> = () => {
  return {
    endpoint: '/przejscie/dostepne-tkd',
  };
};

export const addPrzejscie: MutationFn<AddPrzejscieBody, Pick<Strefa, 'id'>> = (body) => {
  return {
    endpoint: '/przejscie',
    method: 'POST',
    body,
  };
};

export const deletePrzejscie: MutationFn<string, void> = (id) => {
  return {
    endpoint: `/przejscie/${id}`,
    method: 'DELETE',
  };
};
